export enum MessageType {
	InitIceBreakers = 'iceBreakers',
	QuickReplies = 'quickReplies',
	Question = 'question',
	AIText = 'AIText',
	OrderList = 'orderList',
	FashionAssistant = 'fashionAssistant',
	AgentText = 'AgentText',
	AboutAI = 'aboutAI',
	LeaveAgentQueue = 'leaveAgentQueue',
	SearchAddress = 'searchAddress',
}

export enum MessageRole {
	Human = 'human',
	Ai = 'ai',
	Agent = 'agent',
}

export type InitIceBreakersMessage = {
	value: string[]
	type: MessageType.InitIceBreakers
	role: MessageRole.Ai
	showAvatar: false
}

export type QuickRepliesMessageFeedback = 'positive' | 'negative'

export type QuickRepliesMessage = {
	elements: { feedback: QuickRepliesMessageFeedback; optionValue: string }[]
	showAvatar: false
	role: MessageRole.Ai
	type: MessageType.QuickReplies
}

export type ProductMessage = {
	id: string
	color: string
}

export type ReplyOrderListMessage = {
	orders: {
		title: string
		price: string
		date: string
		products: ProductMessage[]
	}[]
	role: MessageRole.Ai
	type: MessageType.OrderList
	showAvatar: false
}

export type QuestionMessage = {
	value: string
	type: MessageType.Question
	role: MessageRole.Human
	showAvatar: true
}

export type AITextMessage = {
	value: string
	type: MessageType.AIText
	role: MessageRole.Ai
	showAvatar: true
	isTimeoutAgentMessage?: boolean
}

export type AgentTextMessage = {
	value: string
	type: MessageType.AgentText
	role: MessageRole.Agent
	showAvatar: true
	isFirstAgentMessage: boolean
	isLastAgentMessage: boolean
}

export type SearchAddressMessage = {
	elements: { optionValue: string; type?: string }[]
	showAvatar: false
	role: MessageRole.Ai
	type: MessageType.SearchAddress
}

export type LeaveAgentQueue = {
	elements: { title: string }
	type: MessageType.LeaveAgentQueue
	role: MessageRole.Agent
	showAvatar: false
}

export type AgentMessage = AgentTextMessage | LeaveAgentQueue

export type AboutAIMessage = {
	value: string
	disclaimers: string[]
	type: MessageType.AboutAI
	role: MessageRole.Ai
	showAvatar: true
}

export type RecommendedProduct = {
	id: string
	colorId: string
	image: string
	url: string
	name: string
}

export type FashionAssistantMessage = {
	recommendations: RecommendedProduct[][] | RecommendedProduct[]
	role: MessageRole.Ai
	showAvatar: false
	type: MessageType.FashionAssistant
}

export type ChatbotMessage =
	| QuestionMessage
	| InitIceBreakersMessage
	| AITextMessage
	| ReplyOrderListMessage
	| QuickRepliesMessage
	| FashionAssistantMessage
	| AgentMessage
	| AboutAIMessage
	| SearchAddressMessage
